import React from 'react';
import PropTypes from 'prop-types';
import Platform from '../shared/Platform';

export default function SocialPresence({ socialPresence }) {
    if (!socialPresence.length) { return null; }

    return (
        <div className="social-media-platforms">
            <h3>{i18n.t('seller_profile.social_presence')}</h3>
            <ul>
                {socialPresence.map((platform, idx) =>
                    <Platform platformData={platform} key={idx}/>)}
            </ul>
        </div>
    );
}

SocialPresence.propTypes = {
    socialPresence: PropTypes.array
};

SocialPresence.defaultProps = {
    socialPresence: []
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/SocialPresence/index.js